import React from 'react'

const IconPortfolio = (props) => {
    return (
        <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2001_260)">
                <path d="M36.0139 9.93722L4.01391 9.99259C1.80477 9.99641 0.0170146 11.7904 0.0208369 13.9995L0.0554413 33.9995C0.0592636 36.2086 1.85322 37.9964 4.06236 37.9926L36.0623 37.9372C38.2714 37.9334 40.0592 36.1394 40.0554 33.9303L40.0208 13.9303C40.017 11.7212 38.223 9.9334 36.0139 9.93722Z" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M28.062 37.9515L28.0067 5.95156C28.0048 4.89069 27.5816 3.87401 26.8302 3.12516C26.0787 2.37632 25.0606 1.95665 23.9997 1.95849L15.9997 1.97233C14.9389 1.97416 13.9222 2.39735 13.1734 3.14879C12.4245 3.90023 12.0048 4.91838 12.0067 5.97924L12.062 37.9792" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2001_260">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default IconPortfolio